import '.ai{flex-shrink:0;}.ssr-plugin'
import '.t{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ay{height:100%;}.ssr-plugin'
import '.b4{border:none;}.ssr-plugin'
import '.cc{background-color:transparent;}.ssr-plugin'
import '.cd{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.bh{position:sticky;}.ssr-plugin'
import '.ce{top:4rem;}.ssr-plugin'
import '.cf{z-index:7;}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.cg{padding-bottom:1rem;}.ssr-plugin'
import '.ch{margin-bottom:1rem;}.ssr-plugin'
import '.ci{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bi{top:0px;}.ssr-plugin'
import '.bo{left:0px;}.ssr-plugin'
import '.bp{right:0px;}.ssr-plugin'
import '.bq{bottom:0px;}.ssr-plugin'
import '.cj{z-index:9999;}.ssr-plugin'
import '.ck{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bm{justify-content:flex-end;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.bz{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ai t n ay b4 cc cd"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e r"
    >
      <div className="bh ce cf a8 cg ch ci d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bi bo bp bq cj a8 ck d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="t d bm ci"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="az bz">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
